<script>
//定义一些公共属性
var globalUrl='';
//var globalUrl = 'http://localhost:56742';
//const globalUrl = 'http://123.60.167.220';
//const globalUrl = 'https://xamyzhaopin.xafa.edu.cn';

//暴露这些属性
export default{
    globalUrl, 
}
</script>
